import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Empleados", icon: "fas fa-address-card", color: "#3b82f6", bg: "#eff6ff", href: "/Empleados", desc: "Directorio de empleados", perm: "menu_empleados" },
  { label: "Puestos",   icon: "fas fa-address-book", color: "#8b5cf6", bg: "#f5f3ff", href: "/Puestos",   desc: "Puestos y roles",          perm: "menu_puestos" },
];

function BotonesNominas() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-users" color="#3b82f6" bg="#eff6ff" title="Recursos Humanos" subtitle="Empleados y puestos" />
        {user.menu_nominas ? (
          <div className="row">
            {ITEMS.map((r, i) => (
              <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            ))}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesNominas;
